(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PicGalleryViewController', PicGalleryViewController);

    PicGalleryViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function PicGalleryViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
